import Card from "@mui/material/Card";
import CardContent from '@mui/material/CardContent';
import { IconButton, Icon } from "@mui/material";
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import { Grid } from "@mui/material";
import { Tooltip } from "@gpstrackit/react-controls";
import { useIntl } from "react-intl";

const CustomCard = (props) => {
    const { messages } = useIntl();
    const { children, onClick, hideButton, width, info, styles, customIcon, customMessage, minWithIcon } = props
    return (
        <Card style={{ marginTop: 5, ...styles }}>
            <CardContent style={{ padding: 10 }}>
                <Grid
                    container
                    alignItems="center"
                    justifyContent="space-between"
                >
                    <Grid item xs={width || 10}>
                        {
                            children
                        }
                    </Grid>
                    {
                        !hideButton &&
                        <Grid item xs={minWithIcon || 2} style={{ display: 'flex', justifyContent: 'end' }}>
                            {
                                info ? (
                                    <Tooltip title={customMessage ? customMessage : messages['common_show_changes']}>
                                        <IconButton style={{ padding: 5 }} onClick={() => onClick()} size="large">
                                            <Icon>info</Icon>
                                        </IconButton>
                                    </Tooltip>
                                ) : (
                                    <Tooltip title={customMessage ? customMessage : messages['common_remove']}>
                                        <IconButton style={{ padding: 5 }} onClick={() => onClick()} size="large">
                                            {customIcon ? customIcon() : <RemoveCircleIcon />}
                                        </IconButton>
                                    </Tooltip>
                                )
                            }
                        </Grid>
                    }
                </Grid>
            </CardContent>
        </Card>
    );
}

export default CustomCard